"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannedUserToJSON = exports.BannedUserFromJSONTyped = exports.BannedUserFromJSON = void 0;
function BannedUserFromJSON(json) {
    return BannedUserFromJSONTyped(json, false);
}
exports.BannedUserFromJSON = BannedUserFromJSON;
function BannedUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'email': json['email'],
        'nickname': json['nickname'],
    };
}
exports.BannedUserFromJSONTyped = BannedUserFromJSONTyped;
function BannedUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'email': value.email,
        'nickname': value.nickname,
    };
}
exports.BannedUserToJSON = BannedUserToJSON;
